/**
 * Instancie une question de la foire aux questions
 */
export class FAQ {
    /**
     * Constructeur de la FAQ
     * @param row Ligne récupérée de la BDD que l'on transforme en objet
     */
    constructor(row) {
        if (row) {
            const { idFaq, titre, contenu, ordre } = row;
            this.idFaq = idFaq !== null && idFaq !== void 0 ? idFaq : null;
            this.titre = titre !== null && titre !== void 0 ? titre : null;
            this.contenu = contenu !== null && contenu !== void 0 ? contenu : null;
            this.ordre = ordre !== null && ordre !== void 0 ? ordre : null;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRkFRLmNsYXNzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiRkFRLmNsYXNzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxPQUFPLEdBQUc7SUFxQmY7OztPQUdHO0lBQ0gsWUFBbUIsR0FBa0I7UUFDcEMsSUFBSSxHQUFHLEVBQUU7WUFDUixNQUFNLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLEdBQUcsR0FBRyxDQUFDO1lBQzdDLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxhQUFMLEtBQUssY0FBTCxLQUFLLEdBQUksSUFBSSxDQUFDO1lBQzNCLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxhQUFMLEtBQUssY0FBTCxLQUFLLEdBQUksSUFBSSxDQUFDO1lBQzNCLElBQUksQ0FBQyxPQUFPLEdBQUcsT0FBTyxhQUFQLE9BQU8sY0FBUCxPQUFPLEdBQUksSUFBSSxDQUFDO1lBQy9CLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxhQUFMLEtBQUssY0FBTCxLQUFLLEdBQUksSUFBSSxDQUFDO1NBQzNCO0lBQ0YsQ0FBQztDQUNEIn0=